export class SignalFunctions
{
    static refreshDueDiligence = "refreshDueDiligence"
    static vetTaskUpdateChanged = "VetTaskUpdateChanged"
    static aiSummaryChanged = "AiSummaryChanged"
    static entityStatusChanged = "EntityStatusChanged"
    static systemRuleChanged = "SystemRuleChanged"
    static dueDiligenceHistoryChanged = "DueDiligenceHistoryChanged"

    
    static entityTypeGroup(entityType: number)  {
        return entityType ? `entity-type-${entityType}` : null;
    }
}